<template>
   <div>
      <FormulaireVisite mode="create" />
   </div>
</template>

<script>
   import FormulaireVisite from "./FormulaireVisite";

   export default {
      components: {
         FormulaireVisite
      },
      mounted() {
         this.$store.commit("setTitre", "Enregistrer une visite");
      }
   };
</script>
